module.exports = __webpack_public_path__ + "static/media/dk.3b3da531.svg";